var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client"},[_c('base-form',{staticClass:"client__form"},[_c('base-card',{staticClass:"client__details",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.details'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"client__body display--grid page--single__grid"},[_c('base-field',{staticClass:"client__body__name",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.name') },
                            input: {
                                component: 'InputBasic',
                                id: 'name',
                                name: 'name',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.name,
                                browserAutocomplete: 'name',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.name,
                                errorOnSubmit: {
                                    show: _vm.errors.api.name ? true : false,
                                    messages: _vm.errors.api.name
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__email",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.email') },
                            input: {
                                component: 'InputBasic',
                                id: 'email',
                                name: 'email',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.email,
                                browserAutocomplete: 'email',
                                fileValidation: 'basicEmail',
                                errors: [{
                                    type: 'email', warning: _vm.$t('error.email')
                                }],
                                errorOnSubmit: {
                                    show: _vm.errors.api.email ? true : false,
                                    messages: _vm.errors.api.email
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__mobile",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.mobile') },
                            input: {
                                component: 'InputBasic',
                                id: 'mobile',
                                name: 'mobile',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.mobile,
                                browserAutocomplete: 'mobile',
                                errorOnSubmit: {
                                    show: _vm.errors.api.mobile ? true : false,
                                    messages: _vm.errors.api.mobile
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__phone",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.phone') },
                            input: {
                                component: 'InputBasic',
                                id: 'phone',
                                name: 'phone',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.phone,
                                browserAutocomplete: 'phone',
                                errorOnSubmit: {
                                    show: _vm.errors.api.phone ? true : false,
                                    messages: _vm.errors.api.phone
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__site",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.website') },
                            input: {
                                component: 'InputBasic',
                                id: 'website',
                                name: 'website',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.model.website,
                                browserAutocomplete: 'website',
                                fileValidation: 'website',
                                errors: [{
                                    type: 'validateWebsite', warning: _vm.$t('error.validateWebsite')
                                }],
                                errorOnSubmit: {
                                    messages: _vm.errors.api.website
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}}),_c('base-field',{staticClass:"client__body__state",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.state') },
                            input: {
                                component: 'States',
                                name: 'state',
                                value: _vm.stateId || 1,
                                dynamicData: {
                                    states: [ 1, 2 ]
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.isEdition
                        }}}),_c('base-field',{staticClass:"client__body__independent",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.independentCaller') },
                            input: {
                                component: 'InputToggle',
                                name: 'independentCaller',
                                id: 'independentCaller',
                                value: _vm.model.independentCaller ? 1 : 0
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: true
                        }}})],1)]},proxy:true}])})],1),(!_vm.$route.meta.isAdd)?[_c('base-card',{staticClass:"client__campaigns page--single__space",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('base-card-header',{attrs:{"title":_vm.$t('global.campaigns'),"actions":{
                        create: { model: 'campaigns' },
                        see: {
                            show: _vm.model.viewMoreCampaigns,
                            link: ("/campaigns?clientId=" + (_vm.model.id))
                        }
                    }}})]},proxy:true},{key:"card__body",fn:function(){return [(_vm.haveCampaigns)?[_c('list',{attrs:{"data":{
                            list: _vm.model.campaigns,
                            headers: [
                                { type: 'default', value: 'beginDate' },
                                { type: 'default', value: 'endDate' },
                                { type: 'default', value: 'type' },
                                {
                                    type: 'component',
                                    value: 'progress',
                                    component:
                                        function () { return import( /* webpackChunkName: 'ProgressBar' */ '@/components/bundles/bars/progress/ProgressBar' ); }
                                }, {
                                    type: 'component',
                                    translate: 'state',
                                    value: 'id',
                                    component: function () { return import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' ); }
                                }
                            ],
                            destak: 'name',
                            model: 'campaigns',
                            hidePagination: true
                        }}})]:_c('div',{staticClass:"client__noassociations"},[_vm._v(_vm._s(_vm.$t('global.noAssociations', { type: _vm.$t('global.campaigns') })))])]},proxy:true}],null,false,370117909)}),_c('base-card',{staticClass:"client__users",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('base-card-header',{attrs:{"title":_vm.$t('global.users'),"actions":{
                        create: { model: 'users' },
                        see: {
                            show: _vm.model.viewMoreUsers,
                            link: ("/users?clientId=" + (_vm.model.id))
                        }
                    }}})]},proxy:true},{key:"card__body",fn:function(){return [(_vm.haveUsers)?[_c('list',{attrs:{"data":{
                            list: _vm.model.users,
                            headers: [
                                {
                                    type: 'component',
                                    value: 'contacts',
                                    component: function () { return import( /* webpackChunkName: 'BaseContacts' */ '@/components/bundles/contacts/BaseContacts' ); }
                                },
                                { type: 'default', value: 'role', isNecessaryTranslate: true },
                                {
                                    type: 'component',
                                    translate: 'state',
                                    value: 'id',
                                    component: function () { return import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseStates' ); }
                                }
                            ],
                            destak: 'name',
                            model: 'users',
                            hidePagination: true
                        }}})]:_c('div',{staticClass:"client__noassociations"},[_vm._v(_vm._s(_vm.$t('global.noAssociations', { type: _vm.$t('global.users') })))])]},proxy:true}],null,false,3657341959)}),_c('base-card',{staticClass:"client__tokens page--single__space",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_c('base-card-header',{attrs:{"title":_vm.$t('global.tokens'),"actions":{
                        create: { model: 'tokens', modal: true, block: _vm.$store.getters.isInEditMode },
                        see: { show: false }
                    }}})]},proxy:true},{key:"card__body",fn:function(){return [_c('base-table',{attrs:{"headers":[
                        'id',
                        'name',
                        'createdAt',
                        'expiresAt'
                    ],"list":_vm.model.accessTokens,"model":"token","settings":{
                        component: 'RowTokens',
                        warning: _vm.$t('global.tokens')
                    }}})]},proxy:true}],null,false,1581214710)})]:_vm._e(),(_vm.showModal)?_c('modal',{key:_vm.showModal,attrs:{"form":{
            settings: {
                typeOfPreparation: 'token'
            }
        },"customSettings":{ color: 'green' },"executeCloseAction":!_vm.loading},on:{"close":function($event){_vm.showModal = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.generateToken'))+" ")]},proxy:true},{key:"modal__body",fn:function(){
        var _obj;
return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.token.value)?_c('div',{staticClass:"client__modal__body display--grid page--single__half"},[_c('base-field',{staticClass:"client__modal__body__token",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.name') },
                        input: {
                            component: 'InputBasic',
                            id: 'tokenName',
                            name: 'tokenName',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'tokenName',
                            isRequired: _vm.$route.meta.isAdd,
                            isMissing: _vm.errors.missing.tokenName,
                            errorOnSubmit: {
                                show: _vm.errors.api.tokenName ? true : false,
                                messages: _vm.errors.api.tokenName
                            },
                            noListener: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"client__modal__body__expires",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.expiresAt') },
                        input: {
                            component: 'InputCalendar',
                            name: 'expiresAt',
                            id: 'expiresAt',
                            targetClass: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'off',
                            errorOnSubmit: {
                                show: _vm.errors.api.expiresAt ? true : false,
                                messages: _vm.errors.api.expiresAt
                            },
                            noListener: true
                        },
                        allowFilling: true
                    }}})],1):[_c('div',{staticClass:"client__modal__token field__input position--relative pointer",on:{"mouseenter":function($event){_vm.token.tooltip.show = true},"mouseleave":function($event){_vm.token.tooltip.show = false},"click":_vm.copyToClipboard}},[_vm._v(" "+_vm._s(_vm.token.value)+" "),_c('tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.token.tooltip.show),expression:"token.tooltip.show"}],staticClass:"client__modal__token__tooltip",class:( _obj = {}, _obj[("client__modal__token__tooltip--style client__modal__token__tooltip--" + (_vm.token.tooltip.class))] = _vm.token.tooltip.show, _obj ),attrs:{"direction":"top","arrow":"center"},domProps:{"innerHTML":_vm._s(_vm.token.tooltip.label ? _vm.$t(("global." + (_vm.token.tooltip.label))) : '')}})],1)]],2),_c('input',{attrs:{"id":"newToken","type":"hidden"},domProps:{"value":_vm.token.value}})]},proxy:true},{key:"modal__info",fn:function(){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.token.value)?_c('div',{staticClass:"client__modal__token__info"},[_vm._v(" "+_vm._s(_vm.$t('global.tokenInfo'))+" ")]):_vm._e()])]},proxy:true}],null,false,2810861155)}):_vm._e(),(!_vm.$route.meta.isAdd)?_c('widget-options'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }